<div class="gov-card">
  <div class="gov-card__header">{{ edit ? 'Edycja' : 'Dodanie' }} działki</div>
  <div class="gov-card__body">
    <form *ngIf="form as form" novalidate autocomplete="off" [formGroup]="form">
      <div class="row">
        @if (form.isEntireParcelCoveredByPlan) {
          <div class="col-12">
            <p>Czy teren objęty planem obejmuje całość działki lub działek ewidencyjnych? *</p>
            <br>
            <div class="form-group">
              <div class="custom-radio custom-inline">
                <input
                  formControlName="isEntireParcelCoveredByPlan"
                  type="radio"
                  id="isEntireParcelCoveredByPlanYes"
                  [value]="true">
                <label for="isEntireParcelCoveredByPlanYes">Tak</label>
              </div>
              <div class="custom-radio custom-inline">
                <input
                  formControlName="isEntireParcelCoveredByPlan"
                  type="radio"
                  id="isEntireParcelCoveredByPlanNo"
                  [value]="false">
                <label for="isEntireParcelCoveredByPlanNo">Nie</label>
              </div>
              <app-validation-errors [control]='form.get("isEntireParcelCoveredByPlan")'>
              </app-validation-errors>
            </div>
          </div>
        }
        <div class="col-md-4">
          <div class='form-group' *ngIf='"precinct" as controlName'>
            <label [for]='controlName'>Obręb *</label>
            <select
              (change)="form.precinctChange(form.getElement($event).value)"
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [id]='controlName'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option *ngFor='let item of form.obrebListForDisplay(allowedNames)()' [value]='item?.name'>
                {{ item?.name }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"registrationNumber" as controlName'>
            <label [for]='controlName'>
              Działka nr *
            </label>
            <input
              (change)="form.registrationNumberChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu numer ewidencyjny'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.parcelId) {
          <div class="col-md-4">
            <div class='form-group' *ngIf='"parcelId" as controlName'>
              <label [for]='controlName'>
                Identyfikator działki
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu identyfikator działki'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.planName) {
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"planName" as controlName'>
              <label [for]='controlName'>
                Nazwa aktu planowania przestrzennego
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwę aktu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.content) {
          <div class="col-md-12">
            <div class='form-group' *ngIf='"content" as controlName'>
              <label [for]='controlName'>
                Treść *
              </label>
              <textarea
                rows="4"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu czego dotyczy zmiana'></textarea>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.landUseClass; as control) {
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"landUseClass" as controlName'>
              <label [for]='controlName'>
                Nazwa lub nazwy klasy przeznaczenia terenu (albo symbol lub symbole klasy przeznaczenia
                terenu) @if (form.hasRequiredValidator(control)) {
                *
              }
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwę lub nazwy klasy przeznaczenia terenu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.maxBuildingCoverage) {
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"maxBuildingCoverage" as controlName'>
              <label [for]='controlName'>
                Maksymalny udział powierzchni <br> zabudowy [%]
              </label>
              <input
                mask="percent.2"
                decimalMarker=","
                [dropSpecialCharacters]="false"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu maksymalny udział powierzchni zabudowy'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.maxBuildingHeight) {
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"maxBuildingHeight" as controlName'>
              <label [for]='controlName'>
                Maksymalna wysokość zabudowy [m]
              </label>
              <input
                mask="separator.2"
                decimalMarker=","
                [dropSpecialCharacters]="false"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu maksymalną wysokość zabudowy'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.minBiologicalArea) {
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"minBiologicalArea" as controlName'>
              <label [for]='controlName'>
                Minimalny udział powierzchni biologicznie czynnej [%]
              </label>
              <input
                mask="percent.2"
                decimalMarker=","
                [dropSpecialCharacters]="false"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu minimalny udział powierzchni biologicznie czynnej'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.landUse; as control) {
          <div class='col-12'>
            <div class='form-group' *ngIf='"landUse" as controlName'>
              <label [for]='controlName'>
                Przeznaczenie/cel podziału *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu przeznaczenie/cel podziału'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.access) {
          <div class='col-12'>
            <div class='form-group' *ngIf='"access" as controlName'>
              <label [for]='controlName'>
                Dojazd *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu opis dojazdu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">
          <i class="fa fa-trash" aria-hidden="true"></i>Anuluj
        </button>
        <button type="button" class="btn btn-secondary" (click)="onSubmit()">
          @if (!edit) {
            <i class="fa fa-plus" aria-hidden="true"></i>Zapisz dane działki
          } @else {
            <i class="fa fa-save"></i>Zaktualizuj dane działki
          }
        </button>
      </div>
    </form>
  </div>
</div>
